/**
 * Formata a data do comentário de acordo com a proximidade temporal
 * @param dateString String da data a ser formatada
 * @returns String formatada conforme as regras
 */
export const formatCommentDate = (dateString: string): string => {
  const commentDate = new Date(dateString);
  const now = new Date();

  if (Number.isNaN(commentDate.getTime())) {
    return dateString;
  }

  const diffMs = now.getTime() - commentDate.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.floor(diffDays / 7);
  const diffYears = Math.floor(diffDays / 365);

  if (diffDays === 0) {
    if (diffHours === 0) {
      return `Há ${diffMinutes} minuto${diffMinutes === 1 ? '' : 's'}`;
    }
    return `Há ${diffHours} hora${diffHours === 1 ? '' : 's'}`;
  }

  if (diffDays < 7) {
    const weekDays = [
      'domingo',
      'segunda-feira',
      'terça-feira',
      'quarta-feira',
      'quinta-feira',
      'sexta-feira',
      'sábado'
    ];
    return weekDays[commentDate.getDay()];
  }

  if (diffWeeks >= 52) {
    return `Há ${diffYears} ano${diffYears === 1 ? '' : 's'}`;
  }

  return `Há ${diffWeeks} semana${diffWeeks === 1 ? '' : 's'}`;
};
